import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "image", "caption", "srOnly"]
  static values = {
    menuUrl: String,
    open: String
  }

  connect() {
    this.onPopState = this.onPopState.bind(this)
    window.addEventListener("popstate", this.onPopState)

    if (this.openValue) {
      this.revealFromSlug(this.openValue)
    }
  }

  disconnect() {
    window.removeEventListener("popstate", this.onPopState)
  }

  open(event) {
    event.preventDefault()

    const trigger = event.currentTarget
    const slug = event.params.slug || trigger.dataset.lightboxSlugParam
    const url = event.params.url || trigger.dataset.lightboxUrlParam
    const src = event.params.src || trigger.dataset.lightboxSrcParam
    const name = event.params.name || trigger.dataset.lightboxNameParam

    if (!src) return

    this.reveal(src, name)

    if (url && slug && !this.currentItemPath(slug)) {
      history.pushState({ lightbox: slug }, "", url)
    }
    this.openValue = slug || ""
  }

  close() {
    this.hide()
    if (this.itemPathActive()) {
      history.pushState({ lightbox: null }, "", this.menuUrlValue)
    }
    this.openValue = ""
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  cancel(event) {
    event.preventDefault()
    this.close()
  }

  onPopState() {
    const slug = this.slugFromLocation()
    if (slug) {
      this.revealFromSlug(slug)
      this.openValue = slug
    } else {
      this.hide()
      this.openValue = ""
    }
  }

  revealFromSlug(slug) {
    const trigger = this.element.querySelector(`[data-lightbox-slug-param="${slug}"]`)
    if (!trigger) {
      this.hide()
      return
    }

    this.reveal(trigger.dataset.lightboxSrcParam, trigger.dataset.lightboxNameParam)
  }

  reveal(src, name) {
    if (!src) return

    this.imageTarget.src = src
    this.imageTarget.alt = `Foto de ${name}`
    this.captionTarget.textContent = name
    this.srOnlyTarget.textContent = `Foto de ${name}`

    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  hide() {
    this.imageTarget.removeAttribute("src")
    this.imageTarget.alt = ""
    this.captionTarget.textContent = ""
    this.srOnlyTarget.textContent = ""
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  slugFromLocation() {
    const match = window.location.pathname.match(/\/i\/([^/]+)$/)
    return match ? decodeURIComponent(match[1]) : ""
  }

  currentItemPath(slug) {
    return window.location.pathname.endsWith(`/i/${slug}`)
  }

  itemPathActive() {
    return /\/i\/[^/]+$/.test(window.location.pathname)
  }
}
